// extracted by mini-css-extract-plugin
export default {"header":"pastdata_header__Dl8l2","title":"pastdata_title__JvYDC","discription":"pastdata_discription__Zpw7p"};